export const setTourDone = () => localStorage.setItem('intro-tour', 'payment');

export const checkIfTourDone = () => localStorage.getItem('intro-tour') === 'payment';

export const destroyTour = () => localStorage.removeItem('intro-tour');
